import React from 'react'

import Format from "../../gd/utils/format"

type Props = {
    model: any
}

export default function WorkdayDurations(props: Props) {

    const weekStartIndex = _.indexOf(['mon','tue','wed','thu','fri','sat','sun'], gd.company.settings.workSchedule.weekStart)
    const durations = _.clone(props.model.workdayDurations)

    // set weekStart as first day in durations array and others arrange accordingly
    for(let i = 0; i < weekStartIndex; i++) {
        const day: any = durations.shift()
        durations.push(day)
    }

    const classes = Classes("flex-row-center-center", "w-40", "h-100-percent")

    return (
        <div className="gd-workday-durations">
            {_.map(durations, (workdayDuration: number, index)=>{
                return (
                    <React.Fragment key={index}>
                        <div key={index} className={Classes(classes, {"ui5-bg-app-gray" : workdayDuration === 0})}>
                            {workdayDuration > 0 && <div className="ui5-txt-less-important-tiny">{Format.minutesToHoursDecimal(workdayDuration)}h</div>}
                        </div>
                        {props.model.workdayDurations.length > (index+1) && <div className="separator"/>}
                    </React.Fragment>
                )
            })}
        </div>
    );
}
